import React from 'react';
import PropTypes from 'prop-types';
import ListItemRemoveButton from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/ListItemRemoveButton';
import fr from 'facet-rest';

function RecurringExpenseItemDeleteButton({ resource, onDelete }) {
  return (
    <ListItemRemoveButton
      resource={resource}
      onDelete={() => onDelete(resource)}
      test={'recurring-expense-item-delete-button'}
      stopPropagation
      useFDButton
      dialogProps={{
        title: resource.attr('removeItemTitle'),
        message: resource.attr('removeItemMessage'),
        cancelLabel: 'Cancel',
        confirmLabel: 'Remove',
      }}
    />
  );
}

RecurringExpenseItemDeleteButton.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onDelete: PropTypes.func.isRequired,
};

RecurringExpenseItemDeleteButton.defaultProps = {
};

export default RecurringExpenseItemDeleteButton;
